module.exports = __webpack_public_path__ + "static/img/new_six.c691db83.jpg";